// The one avatar palette and initials helper, so a student's avatar is the
// same colour on every page.
export const AVATAR_COLORS = [
  '#e0e7ff', '#fce7f3', '#dcfce7', '#fef9c3',
  '#ffedd5', '#f3e8ff', '#dbeafe', '#f0fdf4',
];

export function initials(name) {
  if (!name) return '?';
  return name.split(' ').map((p) => p[0]).join('').slice(0, 2).toUpperCase();
}

export function avatarColor(name) {
  if (!name) return AVATAR_COLORS[0];
  return AVATAR_COLORS[name.charCodeAt(0) % AVATAR_COLORS.length];
}
